package common.dto

import kotlinx.serialization.Serializable

@Serializable
data class Vec3d(
    val x: Double = 0.0, val y: Double = 0.0, val z: Double = 0.0
) {
    override fun equals(other: Any?) = other is Vec3d && other.x == x && other.y == y && other.z == z
    override fun hashCode() = 31 * (31 * x.hashCode() + y.hashCode()) + z.hashCode()
}